import { Stack, Grid, Card, CardContent, Avatar, Typography, Box, ToggleButtonGroup, ToggleButton, Tooltip, Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { AppColors } from '../../../Utils/helper/AppColors';

export function AgentCard({ agent, agentType, onHover = true , showMore = false , img , setIsPickedForShowMore = () => {} , isPickedForShowMore = null}) {
    
    const typographyShortDescriptionRef = useRef(null);
    const typographyLongDescriptionRef = useRef(null);

    const [showMoreState, setShowMoreState] = useState(false);  // only to show btn (show more / show less)
    const [expand, setExpand] = useState(false); // to expand the text

    useEffect(() => {
        
        if (typographyShortDescriptionRef.current || typographyLongDescriptionRef.current) {
            const isOverflowing = typographyShortDescriptionRef.current.scrollHeight > typographyShortDescriptionRef.current.clientHeight;
            const isOverflowingLongDesc = typographyLongDescriptionRef.current.scrollHeight > typographyLongDescriptionRef.current.clientHeight;

            if (isOverflowing || isOverflowingLongDesc) {
                setShowMoreState(true);
            }
            else {
                setShowMoreState(false);
            }
        }
    }, [agentType]);

    useEffect(() => {
        if(isPickedForShowMore && isPickedForShowMore === agent?.id){
            setExpand(true);
        }
        else{
            setExpand(false);
        }
    }, [isPickedForShowMore]);


    return (
        <Card
            sx={{
                textAlign: 'center',
                borderRadius: 3,
                boxShadow: 3,
                p: 3,
                minHeight: '430px', // Dynamically set height
            }}
        >


            <Box
                textAlign="center"
                mb={1}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 2,
                    alignItems: 'center',
                }}


                
            >

                <Avatar
                sx={(theme) => ({
                    bgcolor: theme.palette.primary.lightest_shade,
                    width: 56,
                    height: 56,
                    borderRadius: '16px',
                    paddingLeft: '4px',
                    border: `1px solid ${theme.palette.primary.lighter_shade}`,
                    '& img': { objectFit: 'contain' },
                })}
                src={img}
            >
                
            </Avatar>
                {/* <Typography variant="h6" color="primary" gutterBottom>
                    {agent?.agentDetails?.agentName}
                </Typography> */}

                    <Typography
                        
                        sx={{
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2, // Limit to 2 lines
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textAlign: 'start',
                            fontWeight: 600,
                            fontSize: 20,
                            lineHeight: '28px',
                            wordBreak: 'break-word',
                        }}
                    >
                        {agent?.agentDetails?.agentName || agent?.name}
                    </Typography>
                {/* <Typography variant="body2" color="text.secondary">
                    {agent?.agentDetails?.shortDescription}
                </Typography> */}

                
            </Box>

            {/* <Tooltip title={agent?.agentDetails?.shortDescription} arrow> */}
                    <Typography
                        ref={typographyShortDescriptionRef}
                        sx={{
                            ...(!expand && { display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2, // Limit to 2 lines
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',} ),
                            fontSize: 14,
                            fontWeight: 300,
                            lineHeight: '22px',
                            minHeight : '45px',
                            textAlign : 'left',
                            color : AppColors.HEADING_SUBTITLE,
                            wordBreak : 'break-word',
                            mb : 2

                        }}
                    >
                        {agent?.agentDetails?.shortDescription}
                    </Typography>
                {/* </Tooltip> */}

            <Box textAlign="left" mb={1}>
                <Typography variant="body2" color="text.secondary" mb={1}>
                    <b style={{ color: AppColors.BLACK }}>Agent Type :</b> {agentType}
                </Typography>
                
                {/* <Typography variant="body2">
                    <b>Purpose:</b> {agent?.purpose || 'Ujjwal Sir DalDo backend see'}
                </Typography> */}
                <Typography variant="body2" color="text.secondary" mb={1}>
                    <b style={{ color: AppColors.BLACK }}>Language :</b> {agent?.transcriber?.language}
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={1}>
                    <b style={{ color: AppColors.BLACK }}>Total Hours :</b> {Math?.ceil?.(agent?.maxDurationSeconds / 3600)}
                </Typography>
                
                <Typography variant="body2" color="text.secondary" sx={{ display : 'flex', flexDirection : 'column' , gap : '8px'}}>
                    <b style={{ color: AppColors.BLACK }}>Description :</b>
                    {/* {agent?.agentDetails?.longDescription} */}

                    {/* <Tooltip title={agent?.agentDetails?.longDescription} arrow> */}
                        <Typography
                            ref={typographyLongDescriptionRef}
                            variant="body2"
                            color="text.secondary"
                            dangerouslySetInnerHTML={{ __html: agent?.agentDetails?.longDescription || '' }}
                            sx={{
                            ...(!expand && { display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2, // Limit to 2 lines
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',} ),
                            fontSize: 14,
                            lineHeight: '22px',
                            minHeight : '110px',
                            wordBreak: 'break-word',
                            }}
                        >
                            {/* {agent?.agentDetails?.longDescription} */}
                        </Typography>
                    {/* </Tooltip> */}
                </Typography>
            </Box>

            {showMoreState && <Button
                variant="text"
                color="info"
                sx={{ border : 'none' , color : AppColors.BLACK , fontSize : 12 , fontWeight : 600 , ml : 'auto' , p: 0  }}
                onClick={() => {
                    if(!setIsPickedForShowMore) return;
                    if(!expand){
                        setIsPickedForShowMore(agent?.id);
                    }
                    else{
                        setIsPickedForShowMore(null);
                    }
                    setExpand(!expand);
                }}
            >
                {!expand ? 'Show More' : 'Show Less'}
            </Button>}


        </Card>
    );
}